export default __webpack_public_path__ + "static/create-new-feature-flag-dark-mode-ee9232b506f13fc068349d096b28d990.png";